import { FC, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  TextField,
  IconButton,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface EmailCaptureModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (email: string) => void;
  isLoading?: boolean; // Optional prop to handle loading state
}

export const EmailCaptureModal: FC<EmailCaptureModalProps> = ({ open, onClose, onConfirm, isLoading }) => {
  const [emailaddress, setEmailAddress] = useState<string>('');

  const validateEmail = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailAddress(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    // Validate the email address
    if (!validateEmail(emailaddress)) {
      alert('Please enter a valid email address.');
      return;
    }

    onConfirm(emailaddress);
  };

  return (
    <Dialog open={open} onClose={() => {}} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: 2,
          position: 'relative',
        }}>
        Enter Email
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ marginBottom: 4 }}>
        <form onSubmit={handleSubmit}>
          <Typography align="center" mb={4}>
            Please enter your email address
          </Typography>

          <TextField
            sx={{ marginBottom: 3 }}
            fullWidth
            type="email"
            variant="outlined"
            size="small"
            name="emailaddress"
            label="Email Address"
            required
            onChange={handleChange}
            value={emailaddress}
          />

          <Box display="flex" flexDirection="column" gap={2} alignItems="center">
            <Button
              fullWidth
              disabled={isLoading}
              variant="contained"
              type="submit"
              sx={{
                textTransform: 'none',
                borderRadius: '5px',
                fontWeight: 500,
                backgroundColor: '#3f51b5',
                '&:hover': { backgroundColor: '#354497' },
              }}>
              {isLoading ? (
                <>
                  Confirm&nbsp;
                  <CircularProgress size={20} color="inherit" />
                </>
              ) : (
                'Confirm'
              )}
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};
